import { Link } from 'react-router-dom'
import { SiteFooter } from '@gjl/ui'
import { Mail, Linkedin, Github, Heart, Flame } from 'lucide-react'
import { brand, navLinks, contactCTA } from '@/lib/nav-links'

export function Footer() {
  return (
    <SiteFooter>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-12 text-sm md:grid-cols-3">
        {/* Left: Branding & Copyright */}
        <div className="text-muted-foreground space-y-2">
          <p className="text-foreground font-serif text-xl">{brand}</p>
          <p>© {new Date().getFullYear()} All rights reserved.</p>
        </div>

        {/* Center: Navigation */}
        <div className="text-muted-foreground flex flex-col space-y-2 md:items-center md:space-y-1">
          <p className="text-muted-foreground text-xs tracking-wider uppercase">Explore</p>
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href} className="hover:text-foreground transition">
              {link.label}
            </Link>
          ))}
          <Link to={contactCTA.href} className="hover:text-foreground transition">
            {contactCTA.label}
          </Link>
        </div>

        {/* Right: Contact + Social */}
        <div className="text-muted-foreground space-y-2 md:text-right">
          <p className="text-xs tracking-wider uppercase">Contact</p>
          <p>Los Angeles, CA</p>
          <p>
            <a
              href="mailto:garrett@garrettjohnlaw.com"
              className="hover:text-foreground flex items-center justify-center gap-1 transition md:justify-end"
            >
              <Mail className="h-4 w-4" />
              garrett@garrettjohnlaw.com
            </a>
          </p>
          <div className="flex justify-center gap-4 pt-2 md:justify-end">
            <a
              href="https://www.linkedin.com/in/garrettjohnlaw/"
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Garrett John Law on LinkedIn"
            >
              <Linkedin className="h-5 w-5" aria-hidden="true" />
            </a>
            <a
              href="https://github.com/garrettjohnlaw"
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Garrett John Law on GitHub"
            >
              <Github className="h-5 w-5" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
      <p className="text-muted-foreground mb-6 flex items-center justify-center gap-1 text-center text-sm">
        Made with <Heart className="h-4 w-4 fill-red-500 text-red-500" /> and{' '}
        <Flame className="h-4 w-4 text-orange-500" /> by Garrett John Law
      </p>
    </SiteFooter>
  )
}
